import { render, staticRenderFns } from "./homeShowBox.vue?vue&type=template&id=40df7174&scoped=true"
import script from "./homeShowBox.vue?vue&type=script&lang=js"
export * from "./homeShowBox.vue?vue&type=script&lang=js"
import style0 from "./homeShowBox.vue?vue&type=style&index=0&id=40df7174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df7174",
  null
  
)

export default component.exports